import { TimeUnit } from "@/Common/Models/Enum/TimeUnit";

class TimeInterval {
    public readonly unit: TimeUnit;
    public readonly value: number;

    constructor(unit: TimeUnit, value: number) {
        this.unit = unit;
        this.value = value;
    }

    public static FromMillisecond(value: number): TimeInterval {
        return new TimeInterval(TimeUnit.Millisecond, value);
    }

    public static FromSecond(value: number): TimeInterval {
        return new TimeInterval(TimeUnit.Second, value);
    }

    public static FromMinute(value: number): TimeInterval {
        return new TimeInterval(TimeUnit.Minute, value);
    }

    public static FromHour(value: number): TimeInterval {
        return new TimeInterval(TimeUnit.Hour, value);
    }

    public static FromDay(value: number): TimeInterval {
        return new TimeInterval(TimeUnit.Day, value);
    }

    public static FromWeek(value: number): TimeInterval {
        return new TimeInterval(TimeUnit.Week, value);
    }

    public static FromMonth(value: number): TimeInterval {
        return new TimeInterval(TimeUnit.Month, value);
    }

    public static FromYear(value: number): TimeInterval {
        return new TimeInterval(TimeUnit.Year, value);
    }

    public getUnitNameLabel(): string {
        return cacheStore.GetString(`${TimeUnit[this.unit]}Label`);
    }

    public get isMillisecond(): boolean {
        return this.unit === TimeUnit.Millisecond;
    }

    public get isSecond(): boolean {
        return this.unit === TimeUnit.Second;
    }

    public get isMinute(): boolean {
        return this.unit === TimeUnit.Minute;
    }

    public get isHour(): boolean {
        return this.unit === TimeUnit.Hour;
    }

    public get isDay(): boolean {
        return this.unit === TimeUnit.Day;
    }

    public get isWeek(): boolean {
        return this.unit === TimeUnit.Week;
    }

    public get isMonth(): boolean {
        return this.unit === TimeUnit.Month;
    }

    public get isYear(): boolean {
        return this.unit === TimeUnit.Year;
    }
}

export { TimeInterval };
